import { Component, computed, effect, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { DotsSpinnerComponent } from '@shared/components/dots-spinner/dots-spinner.component';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MaintenanceStore } from './maintenance.store';

@Component({
  imports: [IconBadgeComponent, TranslateModule, MatButtonModule, DotsSpinnerComponent, IconComponent],
  providers: [MaintenanceStore],
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent {
  public readonly isLoading = computed(() => this.maintenanceStore.loading$() || this.reinitializingAuth());

  public readonly maintenanceStore = inject(MaintenanceStore);

  private readonly reinitializingAuth = signal(false);

  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  constructor() {
    effect(() => {
      const health = this.maintenanceStore.health$();

      if (health && health.maintenance !== 'True') {
        this.authService.reinitAuthState();

        return;
      }

      this.reinitializingAuth.set(false);
    });

    this.authService.currentDbUser$.subscribe((user) => {
      if (!user || !this.reinitializingAuth()) {
        this.reinitializingAuth.set(false);

        return;
      }

      this.router.navigate(['/dashboard']);
    });
  }

  public navigateToDashboard(): void {
    this.reinitializingAuth.set(true);
    this.maintenanceStore.fetchHealth();
  }
}
